import utils from '../resources/utils';
import $API from '../services/bixe-api.service';
import { useAccountStore } from '@/store/pinia/account';
import { useUsersStore } from '@/store/pinia/users';

function onActionTaken({ meetingId, next }) {
  const accountStore = useAccountStore();
  if (utils.isOpenedWithinElectronShell()) {
    if (accountStore.canCreate) {
      return next(`/welcome`);
    } else {
      return next(`/meeting-has-been-ended`);
    }
  } else {
    return next(`/meeting-over?id=${meetingId}`);
  }
}

export default () => (to, from, next) => {
  const meetingId = to.query.id;
  const isOnboardingFeedback = to.query.referer === 'onboarding-email';
  const usersStore = useUsersStore();
  const user = usersStore.me;
  if (user?.meta?.guest || isOnboardingFeedback) {
    // for onboarding feedback, we do not even require users to be logged in, no eligibility check needed
    // all guest users are eligible for feedback by default
    next();
    return;
  }

  $API
    .getIsEligibleForFeedback()
    .then((resp) => {
      if (!resp.isEligible) {
        onActionTaken({ meetingId, next });
        return;
      }
      next();
    })
    .catch((err) => {
      console.log('error in verifying feedback eligibility', err);
      onActionTaken({ meetingId, next });
    });
};
